import PlayerShortModel from "../../Player/PlayerShortModel";

export default class LineupsModel {
    public homeTeam: { players: PlayerShortModel[] } = { players: [] };
    public awayTeam: { players: PlayerShortModel[] } = { players: [] };
}